export const visKunVerktoySomKanLeggesTil_checkBoxId = 'visKunVerktoySomKanLeggesTilId';
export const innloggetCheckbox_filterName = 'visKunVerktoySomKanLeggesTil';
export const anonymCheckbox_filterName = 'visKunVerktoySomKanStartesAnonymt';
export const BreadcrumbText = {
  FINN_VERKTOY: 'Finn selvhjelpsverktøy',
  INNBOKS: 'Innboks',
  ENTRY_PAGE: 'Verktøy',
} as const;

export const OPPGAVEID_QUERY_PARAM = 'oppgaveid';
export const INTENSJON_QUERY_PARAM = 'intensjon';
export const OPPGAVE_RETURURL_QUERY_PARAM = 'retururl';
export const IGNORE_CASE = true;

export enum FilterObject_Type {
  CheckBox = 'checkbox',
  Bool = 'bool',
}

export enum UseQueryParamType {
  String = 'string',
  Bool = 'bool',
}
